(function () {
    'use strict';
    angular
        .module('atcCallSign')
        .service('AtcCallSignService', AtcCallSignService);

    function AtcCallSignService(rx, RemoteService, MessageService, AtcCallSignFactory) {

        var self = this;

        self.saveAtcCallSign = function (saveData, successFn, errorFn) {
          RemoteService.saveAtcCallSign(saveData).then(
            function(response) {
              successFn(response.data);
              MessageService.success(MessageService.MESSAGES.COMMON.SUCCESS_SAVED);
            },
            function(error) {
                MessageService.error(error);
                errorFn(error.msg[0]);
            }
          )
        };

        self.searchAtcCallSignValue = function(params,successFn, errorFn) {
          var searchParams = AtcCallSignFactory.getSearchParams(params);
          RemoteService.getAtcCallSignData(searchParams).then(
            function(response) {
              successFn(response.atcCallSignDTOList);
          },
            function(error) {
                MessageService.error(error);
                errorFn(error.msg[0]);
            }
          )
        };

        self.deleteAtcCallSign = function (params,successFn, errorFn) {
          var deleteParams = AtcCallSignFactory.getDeleteParams(params);
          RemoteService.deleteAtcCallSign(deleteParams).then(
            function(response) {
              successFn(response.data);
              MessageService.success(MessageService.MESSAGES.COMMON.DELETE_SUCCESS);
            },
            function(error) {
              MessageService.error(error);
              errorFn(error.msg[0]);
            }
          )
        };

      self.saveConversionToMappingAtcCallSign = function (params,successFn, errorFn) {
        RemoteService.saveConversionToMappingAtcCallSign(params).then(
          function(response) {
            successFn(response.data);
          },
          function(error) {
            MessageService.error(error);
            errorFn(error.msg[0]);
          }
        )
      };

    }
})();
